/**
 * Mas Custom V2 — Sections JavaScript
 * Handles: Shop by Space, Product Carousel, Product Grid Filter
 */
(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initShopBySpace();
    initProductCarousel();
    initProductGridFilter();
  }

  /* ─── Shop by Space ──────────────────────────────────── */

  function initShopBySpace() {
    var roots = document.querySelectorAll('[data-cigar-space-root]');
    if (roots.length) {
      roots.forEach(function (root) {
        var triggers = Array.from(root.querySelectorAll('[data-cigar-space-trigger]'));
        var panels = Array.from(root.querySelectorAll('[data-cigar-space-panel]'));

        if (!triggers.length || !panels.length) return;

        function activatePanel(panelId) {
          triggers.forEach(function (trigger) {
            var isActive = trigger.getAttribute('data-cigar-space-trigger') === panelId;
            trigger.classList.toggle('is-active', isActive);
            trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var isActive = panel.getAttribute('data-cigar-space-panel') === panelId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        }

        triggers.forEach(function (trigger) {
          var panelId = trigger.getAttribute('data-cigar-space-trigger');
          ['mouseenter', 'focus', 'click'].forEach(function (eventName) {
            trigger.addEventListener(eventName, function () {
              activatePanel(panelId);
            });
          });
        });

        activatePanel(triggers[0].getAttribute('data-cigar-space-trigger'));
      });
      return;
    }

    var section = document.querySelector('[data-mc-space-section]');
    if (!section) return;

    var mainImg = section.querySelector('[data-mc-space-main] img');
    var mainLabel = section.querySelector('[data-mc-space-label]');
    var mainTag = section.querySelector('[data-mc-space-main] .mc-space__tag');
    var thumbs = section.querySelectorAll('[data-mc-space-thumb]');

    if (!mainImg || !mainLabel || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // Update active state
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        // Update main image
        var newImg = thumb.getAttribute('data-mc-space-img');
        var newLabel = thumb.getAttribute('data-mc-space-label');

        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(1.02)';

        setTimeout(function () {
          mainImg.src = newImg;
          mainImg.alt = newLabel;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 200);

        // Update label
        if (mainLabel) mainLabel.textContent = newLabel;
        if (mainTag) mainTag.textContent = newLabel;
      });
    });
  }

  /* ─── Product Carousel ─────────────────────────────── */

  function initProductCarousel() {
    var carousels = document.querySelectorAll('[data-mc-carousel]');
    carousels.forEach(function (carousel) {
      initSingleCarousel(carousel);
    });
  }

  function initSingleCarousel(carousel) {
    var track = carousel.querySelector('[data-mc-carousel-track]');
    var prevBtn = carousel.querySelector('[data-mc-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-mc-carousel-next]');

    if (!track) return;

    var card = track.querySelector('[data-mc-carousel-card]');
    if (!card) return;

    var scrollAmount = card.offsetWidth + 20; // card width + gap

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
  }

  /* ─── Product Grid Filter ───────────────────────────── */

  function initProductGridFilter() {
    var section = document.querySelector('[data-mc-grid-filter]');
    if (!section) return;

    var filterBtn = section.querySelector('[data-mc-grid-filter-btn]');
    var filterPanel = section.querySelector('[data-mc-grid-filter-panel]');
    var filterOptions = section.querySelector('[data-mc-grid-filter-options]');
    var filterLabel = section.querySelector('[data-mc-grid-filter-label]');
    var filterCount = section.querySelector('[data-mc-grid-filter-count]');
    var clearButtons = section.querySelectorAll('[data-mc-grid-filter-clear]');
    var gridCards = section.querySelectorAll('[data-mc-grid-card]');
    var totalSpan = section.querySelectorAll('[data-mc-grid-total]');
    var statusEl = section.querySelector('[data-mc-grid-filter-status]');
    var noResultsEl = section.querySelector('[data-mc-grid-no-results]');
    var gridEl = section.querySelector('[data-mc-grid-filter-grid]');

    if (!filterBtn || !filterPanel || !filterOptions || gridCards.length === 0) return;

    // Extract available colors from product tags
    var allColors = [];
    gridCards.forEach(function (card) {
      var colorsStr = card.getAttribute('data-mc-grid-colors') || '';
      if (colorsStr) {
        var colors = colorsStr.split('|||').filter(Boolean).map(function (c) { return c.trim(); });
        colors.forEach(function (c) {
          if (c && allColors.indexOf(c) === -1) {
            allColors.push(c);
          }
        });
      }
    });

    // Color swatch mapping
    var colorSwatches = {
      'black': '#1a1a1a',
      'gold': '#c49a3c',
      'wood': '#8b6914',
      'silver': '#c0c0c0',
      'carbon fiber': '#2d2d2d',
      'carbon_fiber': '#2d2d2d'
    };

    // Build filter options
    filterOptions.innerHTML = '';
    allColors.forEach(function (color) {
      var displayName = color.replace(/_/g, ' ');
      var displayNameCap = displayName.charAt(0).toUpperCase() + displayName.slice(1);
      var swatchColor = colorSwatches[color.toLowerCase()] || '#ccc';

      var btn = document.createElement('button');
      btn.className = 'mc-grid-filter__option';
      btn.setAttribute('data-mc-grid-option', color);
      btn.type = 'button';
      btn.innerHTML =
        '<span class="mc-grid-filter__option-swatch" style="background:' + swatchColor + '"></span>' +
        '<span>' + displayNameCap + '</span>' +
        '<span class="mc-grid-filter__option-check">&#10003;</span>';

      filterOptions.appendChild(btn);
    });

    // Active color set
    var activeColors = [];

    // Rebuild option elements reference
    function getOptions() {
      return section.querySelectorAll('[data-mc-grid-option]');
    }

    function applyFilter() {
      var visibleCount = 0;

      gridCards.forEach(function (card) {
        if (activeColors.length === 0) {
          card.classList.remove('is-hidden');
          visibleCount++;
        } else {
          var cardColors = (card.getAttribute('data-mc-grid-colors') || '').toLowerCase();
          var matches = activeColors.some(function (ac) {
            return cardColors.indexOf(ac.toLowerCase()) !== -1;
          });
          if (matches) {
            card.classList.remove('is-hidden');
            visibleCount++;
          } else {
            card.classList.add('is-hidden');
          }
        }
      });

      // Update count and status
      var total = gridCards.length;
      if (totalSpan.length) {
        totalSpan.forEach(function (el) { el.textContent = activeColors.length > 0 ? visibleCount : total; });
      }

      if (activeColors.length > 0) {
        if (statusEl) {
          statusEl.innerHTML =
            'Showing <span>' + visibleCount + '</span> of <span>' + total + '</span> cabinets &middot; Filtered by color';
        }
      } else {
        if (statusEl) {
          statusEl.innerHTML =
            'Showing <span>' + total + '</span> of <span>' + total + '</span> cabinets';
        }
      }

      // Update filter button
      if (filterLabel) {
        filterLabel.textContent = activeColors.length > 0 ? 'Color (' + activeColors.length + ')' : 'Choose color';
      }
      if (filterCount) {
        filterCount.textContent = activeColors.length > 0 ? activeColors.length : '';
        filterCount.style.display = activeColors.length > 0 ? 'inline-flex' : 'none';
      }
      if (filterBtn) {
        if (activeColors.length > 0) {
          filterBtn.classList.add('is-active');
        } else {
          filterBtn.classList.remove('is-active');
        }
      }

      // Update option active states
      getOptions().forEach(function (opt) {
        var color = opt.getAttribute('data-mc-grid-option');
        if (activeColors.indexOf(color) !== -1) {
          opt.classList.add('is-active');
        } else {
          opt.classList.remove('is-active');
        }
      });

      // Empty state
      if (visibleCount === 0 && activeColors.length > 0) {
        if (noResultsEl) noResultsEl.style.display = 'block';
        if (gridEl) gridEl.style.display = 'none';
      } else {
        if (noResultsEl) noResultsEl.style.display = 'none';
        if (gridEl) gridEl.style.display = '';
      }
    }

    function toggleColor(color) {
      if (color === '__clear__') {
        activeColors = [];
      } else {
        var idx = activeColors.indexOf(color);
        if (idx !== -1) {
          activeColors.splice(idx, 1);
        } else {
          activeColors.push(color);
        }
      }
      applyFilter();
    }

    // Option click handler (delegated)
    filterOptions.addEventListener('click', function (e) {
      var option = e.target.closest('[data-mc-grid-option]');
      if (!option) return;
      var color = option.getAttribute('data-mc-grid-option');
      toggleColor(color);
    });

    // Clear buttons
    clearButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleColor('__clear__');
      });
    });

    // Toggle panel
    filterBtn.addEventListener('click', function () {
      var isOpen = filterPanel.style.display !== 'none';
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    });

    function openPanel() {
      filterPanel.style.display = 'block';
      filterBtn.setAttribute('aria-expanded', 'true');

      // Add backdrop to close on outside click
      var backdrop = document.createElement('div');
      backdrop.className = 'mc-grid-filter__backdrop';
      backdrop.addEventListener('click', function () {
        closePanel();
        backdrop.remove();
      });
      filterPanel.parentNode.appendChild(backdrop);
    }

    function closePanel() {
      filterPanel.style.display = 'none';
      filterBtn.setAttribute('aria-expanded', 'false');
      var backdrop = section.querySelector('.mc-grid-filter__backdrop');
      if (backdrop) backdrop.remove();
    }
  }

})();
